<template lang="pug">
  FormBlock(mobile).b-desc
    ._header Доступы
    ._items(v-if="isTemplate")
      ._item
        span._name Рабочий
        span._text  - пользователи, которые имеют доступ только на <b>копирование</b> шаблона.
      ._item
        span._name Административный
        span._text  - пользователи, которые имеют доступ на <b>копирование</b> и <b>модификацию</b> шаблона.
      ._item
        span._text Этот раздел в первую очередь предназначен для функционала
          a(:href="$router.resolve({ name: 'contacts' }).href")  команд
          |, но Вы так же можете предоставить доступ любому из пользователей из списка Ваших контактов.
    ._items(v-else)
      ._item
        span._name Стандарт
        span._text  - видит только те задачи, в которых принимает участие. Может управлять только своими файлами и комментариями. Может ставить задачи. Не видит коммерческую информацию.
      ._item
        span._name Рабочий
        span._text  - видит все задачи проекта, может создавать новые задачи и управлять разделами. Может управлять участниками задач. Видит всех участников проекта. Не видит коммерческую информацию.
      ._item
        span._name Административный
        span._text  - доступны практически все права, как у автора проекта. Не может архивировать и удалить проект, не может сменить автора проекта.
</template>

<script>
import FormBlock from '@/components/FormBlock.vue';

export default {
  name: 'DescTile',
  components: { FormBlock },
  computed: {
    project() { return this.$store.state.project.project ?? {}; },
    isTemplate() { return this.project.isTemplate; },
  },
};
</script>

<style scoped lang="scss">
  .desc {
    &__header {
      font-size: 18px;
      line-height: 24px;
      color: var(--color-super-dark);
      padding-bottom: 10px;
      margin-bottom: 18px;
      border-bottom: 1px solid #EBEFF2;
    }

    &__items {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    &__name {
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;
      color: #33A1FB;
    }

    &__text {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.01em;

      a {
        color: var(--color-accent) !important;
      }
    }
  }
</style>
